module.exports = __webpack_public_path__ + "img/radio-light.02832060.jpg";